import style from "./styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import logo from "../../assets/asos-premier-2.png";

const PremierUnavailableMessage = () => {
  const translate = useTranslate(useLocaleProvider());

  return (
    <section className={style.PremierUnavailableMessage}>
      <div className={style.inner}>
        <img className={style.logo} src={logo} alt="ASOS Premier" />
        <h1 className={style.title}>
          {translate("premier_landingpage_unavailable_title")}
        </h1>
        <p className={style.description}>
          {translate("premier_landingpage_unavailable_description")}
        </p>
        <div className={style.actions}>
          <a className={style.cta} href="/">
            {translate("premier_landingpage_unavailable_cta")}
          </a>
          <a
            className={style.deliveryLink}
            href="https://www.asos.com/customer-care/delivery/"
          >
            {translate("premier_landingpage_unavailable_delivery_link")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default PremierUnavailableMessage;
